import { render, staticRenderFns } from "./SlsD_Details.vue?vue&type=template&id=2deb0f2a"
import script from "./SlsD_Details.vue?vue&type=script&lang=js"
export * from "./SlsD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports